module.exports = __webpack_public_path__ + "static/media/matilde-cap-china-happy.33c5d7b9.png";